// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"047de87c","513":"9fe09248","703":"a4edf6a3","787":"2deb9ecb"}[chunkId] + ".chunk.js";
};